// Reusable error messages for validation

export const ERROR_MESSAGES = {
  // Required fields
  REQUIRED: "Dieses Feld ist erforderlich.",
  PROPERTY_TYPE_REQUIRED: "Bitte wählen Sie eine Immobilienart.",
  SUB_PROPERTY_TYPE_REQUIRED: "Bitte wählen Sie eine genaue Immobilienart.",

  // Address
  CITY_REQUIRED: "Bitte wählen Sie eine Stadt aus.",
  STREET_REQUIRED: "Bitte geben Sie eine Straße an.",
  HOUSE_NUMBER_REQUIRED: "Bitte geben Sie eine Hausnummer ein.",
  ZIP_CODE_REQUIRED: "Bitte geben Sie eine PLZ ein.",

  // Numbers
  CONSTRUCTION_YEAR_REQUIRED: "Bitte geben Sie das Baujahr ein.",
  LIVING_SPACE_REQUIRED: "Bitte geben Sie die Wohnfläche ein.",
  PLOT_SIZE_REQUIRED: "Bitte geben Sie die Grundstücksfläche ein.",
  BALCONY_SIZE_REQUIRED: "Bitte geben Sie die Größe von Balkon/Terrasse ein.",
  ROOMS_REQUIRED: "Bitte geben Sie die Anzahl der Zimmer ein.",
  COMMERCIAL_UNITS_REQUIRED: "Bitte geben Sie die Anzahl der Einheiten ein.",
  COMMERCIAL_AREA_REQUIRED: "Bitte geben Sie die Fläche ein.",

  // Selections
  BASEMENT_REQUIRED: "Bitte wählen Sie, ob unterkellert vorhanden ist.",
  EQUIPMENT_REQUIRED: "Bitte wählen Sie eine Ausstattung.",
  CONDITION_REQUIRED: "Bitte wählen Sie den Zustand.",
  QUALITY_REQUIRED: "Bitte wählen Sie einen Entwicklungsstand.",
  REASON_REQUIRED: "Bitte wählen Sie einen Grund.",
  TIMELINE_REQUIRED: "Bitte wählen Sie einen zeitlichen Horizont.",

  // Contact
  FIRST_NAME_REQUIRED: "Bitte geben Sie Ihren Vornamen ein.",
  LAST_NAME_REQUIRED: "Bitte geben Sie Ihren Nachnamen ein.",
  EMAIL_REQUIRED: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
  EMAIL_INVALID: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  PHONE_REQUIRED: "Bitte geben Sie Ihre Telefonnummer ein.",
  ACCEPT_CONTACT_REQUIRED: "Bitte akzeptieren Sie die Datenschutzbestimmungen.",

  // Format
  MIN_LENGTH: (min: number) => `Mindestens ${min} Zeichen erforderlich.`,
  MAX_LENGTH: (max: number) => `Maximal ${max} Zeichen erlaubt.`,
  MIN_VALUE: (min: number) => `Mindestwert: ${min}`,
  MAX_VALUE: (max: number) => `Maximalwert: ${max}`,
} as const;
